// JUST + Upcart integration – GYL
(function() {
    console.log('[JUST][GYL] Upcart integration loading...');

    const JUST_CONFIG = {
        app_id: '82d955d6-f8ba-4b82-b52c-e37aa74e3c98', // <-- REPLACE
        domain: 'GYL',                  // <-- REPLACE with JUST domain key
        source: 'cart'
    };

    function isJustAvailable() {
        if (!window.customElements || !customElements.get('just-pay-button')) {
            console.error('[JUST][GYL] <just-pay-button> is NOT registered. Check that the JUST script is loaded on this page.');
            return false;
        }
        console.log('[JUST][GYL] <just-pay-button> is registered.');
        return true;
    }

    function triggerJustCheckout() {
        console.log('[JUST][GYL] triggerJustCheckout called');

        // 1. Make sure JUST web component exists
        if (!isJustAvailable()) {
            return;
        }

        // 2. Try to get cart data (but don't block if it fails)
        try {
            if (typeof window.upcartGetCart === 'function') {
                const data = window.upcartGetCart();
                console.log('[JUST][GYL] upcartGetCart result:', data);
            } else {
                console.log('[JUST][GYL] window.upcartGetCart is not a function (OK, continuing)');
            }
        } catch (e) {
            console.warn('[JUST][GYL] Error calling upcartGetCart (OK, continuing):', e);
        }

        // 3. Try to close Upcart drawer
        try {
            if (typeof window.upcartCloseCart === 'function') {
                console.log('[JUST][GYL] Closing Upcart drawer');
                window.upcartCloseCart();
            } else {
                console.log('[JUST][GYL] window.upcartCloseCart is not a function');
            }
        } catch (e) {
            console.warn('[JUST][GYL] Error calling upcartCloseCart:', e);
        }

        // 4. Prefer an existing JUST button if present
        const existing = document.querySelector('just-pay-button');
        if (existing) {
            console.log('[JUST][GYL] Found existing <just-pay-button>, clicking it');
            clickJustButton(existing);
            return;
        }

        // 5. Fallback: create a hidden JUST button and click it
        console.log('[JUST][GYL] Creating temporary <just-pay-button> for trigger');
        const tempButton = document.createElement('just-pay-button');
        tempButton.setAttribute('app_id', JUST_CONFIG.app_id);
        tempButton.setAttribute('domain', JUST_CONFIG.domain);
        tempButton.setAttribute('source', JUST_CONFIG.source);
        tempButton.style.cssText = 'position: fixed; top:-9999px; left:-9999px; opacity:0;';
        document.body.appendChild(tempButton);

        clickJustButton(tempButton);
    }

    function clickJustButton(el) {
        let attempts = 0;
        const maxAttempts = 15;
        const intervalMs = 300;

        // Also try clicking the host itself (in case JUST listens on host)
        console.log('[JUST][GYL] Clicking <just-pay-button> host element');
        try {
            el.click();
        } catch (e) {
            console.warn('[JUST][GYL] Error clicking host element:', e);
        }

        const interval = setInterval(() => {
            attempts++;
            if (el.shadowRoot) {
                const innerBtn =
                    el.shadowRoot.querySelector('button, [role="button"], div');

                if (innerBtn) {
                    console.log('[JUST][GYL] Found inner JUST button, clicking it (attempt ' + attempts + ')');
                    try {
                        innerBtn.click();
                    } catch (e) {
                        console.error('[JUST][GYL] Error clicking inner JUST button:', e);
                    }
                    clearInterval(interval);
                    return;
                }

                console.log('[JUST][GYL] shadowRoot OK, inner button not yet ready (attempt ' + attempts + ')');
            } else {
                console.log('[JUST][GYL] Waiting for shadowRoot (attempt ' + attempts + ')');
            }

            if (attempts >= maxAttempts) {
                console.error('[JUST][GYL] Failed to find/click JUST inner button after ' + maxAttempts + ' attempts');
                clearInterval(interval);
            }
        }, intervalMs);
    }

    // Method 1: postMessage from Upcart iframe
    window.addEventListener('message', function(event) {
        console.log('[JUST][GYL] window message:', event.data);
        if (event.data && event.data.type === 'JUST_CHECKOUT_CLICKED') {
            console.log('[JUST][GYL] PostMessage received – triggering JUST checkout');
            triggerJustCheckout();
        }
    });

    // Method 2: flag on window
    setInterval(() => {
        if (window.justCheckoutRequested) {
            console.log('[JUST][GYL] justCheckoutRequested flag detected – triggering JUST checkout');
            window.justCheckoutRequested = false;
            triggerJustCheckout();
        }
    }, 500);

    // Method 3: localStorage
    let lastCheckoutRequest = localStorage.getItem('justCheckoutRequest') || '0';
    setInterval(() => {
        const current = localStorage.getItem('justCheckoutRequest') || '0';
        if (current !== lastCheckoutRequest && current !== '0') {
            console.log('[JUST][GYL] localStorage JUST request detected – triggering JUST checkout');
            lastCheckoutRequest = current;
            triggerJustCheckout();
            localStorage.removeItem('justCheckoutRequest');
        }
    }, 500);
})();